//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _customerWorkflow from './customerWorkflow';
import _notificationRule from './notificationRule';
export const customerWorkflow = _customerWorkflow;
export const notificationRule = _notificationRule;
export default {customerWorkflow, notificationRule};

